// ─── Temporary Schedule wizard step definitions ───────────────────────────

export const TEMPSCHEDULE_STEPS = [
  {
    key: 'employee_id',
    label: 'Employee ID (Roll No.):',
    hint: 'The employee whose schedule will be temporarily changed (e.g. EMP001).',
  },
  {
    key: 'timetable',
    label: 'Timetable name:',
    hint: 'The timetable to apply temporarily (e.g. "Morning Shift TT").',
  },
  {
    key: 'start_date',
    label: 'Start date (YYYY-MM-DD):',
    hint: 'First day the temporary schedule takes effect (e.g. 2026-06-01).',
  },
  {
    key: 'end_date',
    label: 'End date (YYYY-MM-DD), or type "skip" for open-ended:',
    hint: 'Last day of the temporary schedule. Type "skip" to leave open-ended.',
  },
]
